module.exports = __webpack_public_path__ + "static/media/2018_conf _Success_Requires_Making_Tough_Decisions.868fc334.png";